import { InjectionToken } from "@angular/core";

export const ENV = new InjectionToken<Environment>('trend_environment');

export const CONSTANTS = new InjectionToken<Constants>('trend_constants');

/**
 * Which Trendmulti client surface this application is — SPEC-2026-09-internal-chat-pwa.
 * Mirrors the backend `ClientSurfaceEnum`: the JWT `surface` claim, the socket
 * handshake and the push-registration source all carry these values.
 *
 * Not to be confused with the Webchat channel (`WEBCHAT_API`), which serves website
 * visitors.
 */
export enum ClientSurfaceEnum {
  /** The main product (`trendmulti-web-app`), chat bubble included. */
  WEB_APP = 'WEB_APP',
  /** The standalone, installable chat app (`trendmulti-web-chat`). */
  WEB_CHAT = 'WEB_CHAT',
}

/** Provided by each application: its own surface. Absent = WEB_APP. */
export const CLIENT_SURFACE = new InjectionToken<ClientSurfaceEnum>('trendmulti_client_surface');

export interface Environment {
  [key: string]: string | boolean | object | unknown;
}

export interface Constants {
  [key: string]: string;
}